export default __webpack_public_path__ + "static/media/banner2.29eb4d32.jpg";